import {
  Button,
  FileDownloadIcon,
  MailIcon,
  SearchIcon,
  Stack,
  TablePager,
} from '@fukuri-admins/ui/common';
import { TextInput } from '@fukuri-admins/ui/common/Form/FormItems';
import { PendingUserTableContent } from './PendingUserTableContent';
import styles from './styles.module.scss';

type PendingUserTableContentProps = React.ComponentProps<typeof PendingUserTableContent>;
type Props = {
  pendingUsers: PendingUserTableContentProps['rows'];
  keyword: string;
  pendingRate: number;
  totalCount: number;
  totalPendingCount: number;
  pagerProps: React.ComponentProps<typeof TablePager>;
  handleKeywordChange: (value: string) => void;
  handleSearch: () => void;
  handleOutputCsv: () => Promise<void>;
  handleHeaderSort: PendingUserTableContentProps['onSort'];
  onClickRow: PendingUserTableContentProps['onClickRow'];
  onClickSendReminder: PendingUserTableContentProps['onClickSendReminder'];
  onOpenBulkConfirm: () => void;
};

export const PendingUserPresentation: React.FC<Props> = ({
  pendingUsers,
  keyword,
  pendingRate,
  totalCount,
  totalPendingCount,
  pagerProps,
  handleKeywordChange,
  handleSearch,
  handleOutputCsv,
  handleHeaderSort,
  onClickRow,
  onClickSendReminder,
  onOpenBulkConfirm,
}) => {
  return (
    <div className={styles.Root}>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        className={styles.Root__Toolbar}
      >
        <Stack direction='row' alignItems='center' gap={8}>
          <div className={styles.Root__SearchInput}>
            <TextInput
              startIcon={<SearchIcon size='xs' className={styles.Root__SearchIcon} />}
              placeholder='氏名・メールアドレスで検索'
              value={keyword}
              onChange={e => handleKeywordChange(e.target.value)}
            />
          </div>
          <Button variant='secondary' size='md' onClick={handleSearch}>
            検索
          </Button>
        </Stack>

        <Stack direction='row' alignItems='center' gap={8}>
          <Button
            variant='outline'
            size='md'
            icon={<FileDownloadIcon size='xs' />}
            iconPosition='left'
            onClick={handleOutputCsv}
          >
            CSVダウンロード
          </Button>
          <Button
            variant='primary'
            size='md'
            icon={<MailIcon size='xs' />}
            iconPosition='left'
            onClick={onOpenBulkConfirm}
          >
            再招待メールを一括送信
          </Button>
        </Stack>
      </Stack>

      <p className={styles.Root__Stats}>
        初回ログイン未完了者 <span className={styles.Root__Stats__Count}>{totalPendingCount}</span>{' '}
        / {totalCount}人（{pendingRate}%）
      </p>

      <div className={styles.tableWrapper}>
        <PendingUserTableContent
          rows={pendingUsers}
          onSort={handleHeaderSort}
          onClickRow={onClickRow}
          onClickSendReminder={onClickSendReminder}
        />
      </div>
      <TablePager {...pagerProps} />
    </div>
  );
};
